module.exports = __webpack_public_path__ + "static/media/close-black.d9d9cac6.svg";